<template>
  <div class="add-rule">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toGoodsPromotion">活动竞价/</span>
        {{ title }}
      </template>
      <template v-slot:content>
        <div class="add-rule-main">
          <div class="table" ref="steps">
            <el-table :data="addTableData" :span-method="objectSpanMethod" style="width: 100%">
              <el-table-column
                prop="goodsName"
                label="商品名称"
                width="240"
              >
                <template slot-scope="scope">
                  <p
                    class="name"
                    :title="scope.row.goodsName"
                    v-html="scope.row.goodsName"
                  ></p>
                </template>
              </el-table-column>
              <el-table-column
                prop="specifications"
                label="商品规格"
              ></el-table-column>
              <el-table-column
                prop="price"
                label="市场价"
              ></el-table-column>
              <el-table-column label="当前竞价金额">
                <template slot-scope="scope">
                  <el-input
                    v-model="biddingPrice"
                    :disabled="disabledBiddingPrice" 
                    @blur="basePrice(biddingPrice)"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="促销数量" min-width="100">
                <template slot-scope="scope">
                  <el-input
                    :disabled="id?true:false"
                    class="gray"
                    @input="changePromotionNum(scope.$index,scope.row.promotionNum)"
                    v-model="scope.row.promotionNum"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="!disabled" min-width="80">
                <template slot-scope="scope">
                  <el-button
                    :disabled="disabled"
                    class="btn-text"
                    type="text"
                    @click="removeGoods(scope.$index)"
                  >删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="add-clear">
              <p v-if="!disabled&&!id">
                <el-button
                  v-if="addTableData.length===0"
                  class="btn-text"
                  type="text"
                  @click="openDialog"
                  :disabled="disabled"
                >新增商品</el-button>
                <el-button
                  v-else
                  class="btn-text"
                  type="text"
                  :disabled="disabled"
                  @click="clearTableData"
                >清除商品</el-button>
              </p>
            </div>
          </div>
          <el-form :model="ruleForm" ref="ruleForm" label-width="100px">
            <el-form-item label="促销规则：" prop="rule">
              <el-radio-group v-model="ruleForm.rule">
                <el-radio :label="1" :disabled="ruleForm.rule == 2">
                  <span>商品直降</span>
                  <el-input
                    :disabled="disabled||ruleForm.rule == 2"
                    class="white"
                    @input="changeReducePrice(reducePrice)"
                    v-model="reducePrice"
                  ></el-input>
                  <span>元</span>
                </el-radio>
                <el-radio :label="2" :disabled="ruleForm.rule == 1">
                  <p>阶梯促销</p>
                </el-radio>
              </el-radio-group>
              <ul class="ladderlist">
                <li
                  class="ladderlist-child"
                  v-for="(value, index) in ladderPromotionData"
                  :key="index"
                >
                  <span>订单数量满</span>
                  <el-input
                    :disabled="disabled||ruleForm.rule == 1"
                    class="white"
                    @input="changeOrderNum(index, value.num)"
                    @blur="watchOrderNum(index, value.num)"
                    v-model="value.num"
                  ></el-input
                  >,商品价统一减￥
                  <el-input
                    :disabled="disabled||ruleForm.rule == 1"
                    class="white"
                    @input="changeOrderPrice(index, value.price)"
                    v-model="value.price"
                  ></el-input>
                  <el-button
                    v-if="index > 0 && !disabled"
                    type="text"
                    class="btn-text"
                    :disabled="disabled"
                    @click="deleteLadderPromotion(index)"
                    >删除</el-button
                  >
                </li>
              </ul>
              <p class="addLi">
                <el-button
                  type="text"
                  :disabled="disabled||ruleForm.rule == 1"
                  class="btn-text"
                  @click="addLadderPromotion"
                  >+添加区间</el-button
                >
              </p>
            </el-form-item>
            <el-form-item label="每人限购：">
              <el-input
                v-model="ruleForm.scopeNum"
                @input="changeScopeNum(ruleForm.scopeNum)"
                class="white w160"
                placeholder="请输入数量"
              ></el-input>
            </el-form-item>
          </el-form>
          <div class="bottom">
            <div class="operations" ref="operations">
              <el-button class="btn-white" @click="cancel">取消</el-button>
              <el-button class="btn-blue" @click="savePromotionGoods"
                >保存</el-button
              >
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
    <!-- 添加商品--弹框 -->
    <el-dialog
      title="添加商品"
      :visible.sync="dialogTableVisible"
      width="1200px"
      top="20vh"
    >
      <!-- 黑色的线条 -->
      <div class="border"></div>
      <!-- 表格部分 -->
      <div class="flex">
        <div class="flex-left">
          <div class="dialog-search">
            <el-cascader
              clearable
              class="gray w160"
              v-model="dialogForm.classify"
              :options="classify"
              :props="defaultParams"
              placeholder="请选择分类"
              filterable
              :show-all-levels="false"
            ></el-cascader>
            <el-input
              class="gray"
              placeholder="请输入商品名称"
              clearable
              @keyup.enter.native="searchGoods"
              v-model="dialogForm.goodsName"
            ></el-input>
            <el-button type="text" class="btn-blue" @click="searchGoods"
              >搜索</el-button
            >
          </div>
          <div class="table-img">
            <el-table height="260" :data="dialogTableList" style="width: 100%">
              <el-table-column label="商品名称" width="250">
                <template slot-scope="scope">
                  <img :src="scope.row.img" class="img" />
                  <p class="name">{{ scope.row.goodsName }}</p>
                </template>
              </el-table-column>
              <el-table-column
                label="商品分类"
                prop="classify"
              ></el-table-column>
              <el-table-column width="80">
                <template slot-scope="scope">
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="choiceGoods(scope.row)"
                    >选择</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="table_pagination">
              <pagination-modul
                :total="total"
                :pageCount="pageCount"
                :currentPage="page"
                @queryChange="updatePage"
              ></pagination-modul>
            </div>
          </div>
        </div>
        <div class="flex-right">
          <div class="specifications">
            <div class="specifications-left">
              <p class="specifications-title">
                <svg
                  t="1574320686487"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="8502"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  width="22"
                  height="22"
                >
                  <path
                    d="M881 512c0-52.4 32.9-96.8 79-114.5-11-43.2-28-83.9-50.2-121.3C864.6 296.3 810 288.1 773 251c-37-37-45.2-91.7-25.1-136.8C710.4 92 669.7 75 626.5 64c-17.8 46.1-62.2 79-114.5 79-52.4 0-96.8-32.9-114.5-79-43.2 11-83.9 28-121.3 50.2 20.1 45.2 11.9 99.8-25.1 136.8-37 37-91.7 45.2-136.8 25.2C92 313.6 75 354.3 64 397.5c46.1 17.8 79 62.2 79 114.5 0 52.4-32.9 96.8-79 114.5 11 43.2 28 83.9 50.2 121.3C159.4 727.7 214 735.9 251 773c37 37 45.2 91.7 25.1 136.8C313.6 932 354.3 949 397.5 960c17.8-46.1 62.2-79 114.5-79 52.4 0 96.8 32.9 114.5 79 43.2-11 83.9-28 121.3-50.2-20.1-45.2-11.9-99.8 25.1-136.8 37-37 91.7-45.2 136.8-25.2C932 710.4 949 669.7 960 626.5c-46.1-17.7-79-62.1-79-114.5zM512 635c-67.9 0-123-55.1-123-123s55.1-123 123-123 123 55.1 123 123-55.1 123-123 123z"
                    p-id="8503"
                    fill="#cdcdcd"
                  />
                </svg>
              </p>
              <p
                class="specifications-list"
                v-for="(value, index) in selectDialogGoods.specifications"
                :key="index"
              >
                <span class="specifications-label">{{ value.title }}：</span>
                <el-select v-model="value.value" class="gray">
                  <el-option
                    v-for="item in value.options"
                    :key="item.name"
                    :value="item.name"
                  ></el-option>
                </el-select>
              </p>
            </div>
            <el-button class="btn-blue" @click="addGoodsItems">添加</el-button>
          </div>
          <div class="table-img">
            <el-table
              height="260"
              :data="selectDialogTableData"
              style="width: 100%"
            >
              <el-table-column label="商品名称" width="240">
                <template slot-scope="scope">
                  <img :src="scope.row.img" class="img" />
                  <p class="name">{{ scope.row.goodsName }}</p>
                </template>
              </el-table-column>
              <el-table-column
                label="商品规格"
                prop="specificationsStr"
              ></el-table-column>
              <el-table-column
                label="可售库存"
                prop="saleNum"
                width="100"
              ></el-table-column>
              <el-table-column width="80">
                <template slot-scope="scope">
                  <el-button
                    class="btn-text"
                    type="text"
                    @click="deleteGoodsItems(scope.$index)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="saveGoodsSku">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import PaginationModul from "base/PaginationTpl";
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
export default {
  components: {
    SecondMenuLinkContent,
    PaginationModul
  },
  data() {
    return {
      id: "",
      title: "新增商品",
      goodsId: "",
      biddingPrice: "", //竞价金额
      disabled: false,
      // 选取的商品sku
      addTableData: [],
      ruleForm: {
        scopeNum: "",
        rule: 1,
      },
      reducePrice: "",
      ladderPromotionData: [
        {
          num: "",
          price: "",
        },
      ],
      // 选择商品--弹框
      dialogTableVisible: false,
      // 弹窗表单
      dialogForm: {
        classify: [],
        goodsName: "",
      },
      // 弹窗搜索值
      dialogFormSearch: {
        classify: [],
        goodsName: "",
      },
      // 分类数据
      classify: [],
      defaultParams: {
        label: "cateName",
        value: "id",
        children: "children"
      },
      // 弹窗商品列表
      dialogTableList: [],
      total: 0,
      page: 1,
      pageCount: 5,
      // 选中的商品的详细数据
      selectDialogGoods: {
        id: "",
        items: [],
        specifications: [],
      },
      // 选择选中的商品的sku的数据
      selectDialogTableData: [],
      disabledBiddingPrice: false
    };
  },
  beforeCreate() {
  },
  created() {
    this.getGoodsClassify()
    this.getGoodsListData()
    this.ruleForm.rule = this.$route.query.promotionType
    // this.biddingPrice = this.$route.query.basePrice
    let id = this.$route.query.id;
    let detail = this.$route.query.detail;
    this.id = id;
    if (id && detail) {
      this.disabled = true;
      this.title = "新增商品";
    } else {
      if (id) {
        this.title = "规则编辑";
        this.disabledBiddingPrice = true
        this.getSupplierBiddingGoodsInfo()
      }
    }
  },
  mounted() {
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.steps.clientWidth + paddingWidth + "px";
    window.onresize = () => {
      if (this.$refs.operations) {
        this.$refs.operations.style.width =
          this.$refs.steps.clientWidth + paddingWidth + "px";
      }
    };
  },
  methods: {
    toGoodsPromotion() {
      this.$router.push(
        "/supplier/spl-bidding/bidding-index/bidding-activities"
      );
    },
    // 限制数量
    changeScopeNum(num) {
      this.ruleForm.scopeNum = this.regNum(num);
    },
    // 促销数量
    changePromotionNum(index, num) {
      this.$set(this.addTableData[index], "promotionNum", this.regNum(num));
    },
    // 限制商品直降价钱
    changeReducePrice(price) {
      this.reducePrice = this.regPrice(price);
    },
    // 限制阶梯促销数量
    changeOrderNum(index, num) {
      this.$set(this.ladderPromotionData[index], "num", this.regNum(num));
    },
    // 限制阶梯促销价钱
    changeOrderPrice(index, price) {
      this.$set(this.ladderPromotionData[index], "price", this.regPrice(price));
    },
    // 判断当前数是否比上一个数大
    watchOrderNum(index, num) {
      if (index > 0) {
        if (
          Number(num) <= Number(this.ladderPromotionData[index - 1].num) ||
          this.ladderPromotionData[index - 1].num === ""
        ) {
          this.$set(this.ladderPromotionData[index], "num", "");
          this.$message.error("当前数量必须必前一个数大");
        }
      }
    },
    // 正整数输入
    regNum(num) {
      let retailNum = num.toString().match(/^\d*/g)
        ? num === "0"
          ? ""
          : num.toString().match(/^\d*/g)[0]
        : "";
      return retailNum;
    },
    // 价钱输入
    regPrice(price) {
      let RetailPrice = price.toString().match(/^\d*(\.?\d{0,2})/g)
        ? price === "00"
          ? "0"
          : price.toString().match(/^\d*(\.?\d{0,2})/g)[0]
        : "";
      return RetailPrice;
    },
    // 添加阶梯促销
    addLadderPromotion() {
      if (this.ladderPromotionData.length < 5) {
        let obj = {
          num: "",
          price: "",
        };
        this.ladderPromotionData.push(obj);
      } else {
        this.$message.error("最多添加5个阶梯促销");
      }
    },
    // 删除阶梯促销
    deleteLadderPromotion(index) {
      this.ladderPromotionData.splice(index, 1);
    },
    // 保存商品
    savePromotionGoods() {
      let aId = Number(this.$route.query.aid)
      let goodsId = this.goodsId;
      let buyLimit = Number(this.ruleForm.scopeNum);
      let promotionType = this.ruleForm.rule;
      let descend = Number(this.reducePrice);
      let biddingPriceNum = this.biddingPrice === ''?0:this.biddingPrice
      let biddingPrice = Number(biddingPriceNum)
      let ladderVos = [];
      let stop = false;
      this.ladderPromotionData.map((value) => {
        let obj = {};
        obj.full = Number(value.num);
        obj.reduce = Number(value.price);
        ladderVos.push(obj);
        if (value.num === "" || value.price === "") {
          stop = true;
        }
      });
      let promotionDetailList = [];
      let stop2 = false;
      this.addTableData.map((value) => {
        let obj = {};
        obj.itemId = value.id;
        obj.num = Number(value.promotionNum);
        promotionDetailList.push(obj);
        if (value.promotionNum === "") {
          stop2 = true;
        }
      });
      if (!goodsId) {
        this.$message.error("请添加商品");
        return false;
      }
      if (biddingPrice==0) {
        this.$message.error("请输入当前竞价金额");
        return;
      }
      if (stop2) {
        this.$message.error("请输入促销数量");
        return;
      }
      if (promotionType === 1 && descend === 0) {
        this.$message.error("请输入商品直降价");
        return false;
      }
      if (promotionType === 2 && stop) {
        this.$message.error("请输入阶梯促销价");
        return false;
      }
      if (this.id) {
        this.$confirm('该商品需要重新审核，是否确认保存？', '保存', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          customClass: 'rule-messageBox',
          confirmButtonClass: 'btn-blue',
          cancelButtonClass: 'btn-white',
        }).then(() => {
          let ladderJson = ladderVos
          let agId = this.id
          let data = {
            agId,
            buyLimit,
            descend,
            ladderJson
          }
          if (promotionType === 1) {
            delete data.ladderJson;
          } else if (promotionType === 2) {
            delete data.descend;
          }
          supplier.getSupplierModifyRule(data).then((res) => {
            if (res.success) {
              this.$message.success("修改成功");
              this.$router.go(-1)
            } else {
              this.$message.error(res.message);
            }
          });
        })
      } else {
        let data = {
          aId,
          goodsId,
          buyLimit,
          biddingPrice,
          promotionType,
          descend,
          ladderVos,
          promotionDetailList,
        };
        if (promotionType === 1) {
          delete data.ladderVos;
        } else if (promotionType === 2) {
          delete data.descend;
        }
        supplier.getSupplierBiddingGoodsAdd(data).then((res) => {
          if (res.success) {
            this.$router.go(-1)
          } else {
            this.$message.error(res.message);
          }
        });
      }
    },
    // 取消
    cancel() {
      this.$router.go(-1);
    },
    openDialog() {
      this.dialogTableVisible = true
    },
    // 商品列表搜索
    searchGoods() {
      this.dialogFormSearch = this.dialogForm;
      this.getGoodsListData();
    },
    // 获取商品列表数据
    getGoodsListData() {
      let length = this.dialogFormSearch.classify.length;
      let category1Id;
      if (length > 0) {
        category1Id = this.dialogFormSearch.classify[length - 1];
      } else {
        category1Id = "";
      }
      let goodsName = this.dialogFormSearch.goodsName;
      let currentPage = this.page;
      let options = {
        currentPage,
        category1Id,
        goodsName
      };
      supplier.getSupplierBiddingGoodsDetail(options).then(res => {
        if (res.success) {
          this.total = res.result.totalNum;
          let arr = [];
          res.result.items.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.img = value.itemImages[0]
              ? value.itemImages[0]
              : "http://image.8844it.com/ydb2/goodDefault.png";
            obj.goodsName = value.goodsName;
            obj.classify = value.categoryName;
            obj.items = value.items;
            obj.specificationItems = value.specificationItems;
            arr.push(obj);
          });
          this.dialogTableList = arr;
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      });
    },
    // 点击商品列表选择按钮
    choiceGoods(row) {
      this.selectDialogTableData = [];
      this.selectDialogGoods.id = row.id;
      let Arr = [];
      row.specificationItems.map(v => {
        let object = {};
        object.title = v.name;
        object.value = v.value[0];
        object.options = [];
        v.value.map(val => {
          let objOptions = {};
          objOptions.name = val;
          object.options.push(objOptions);
        });
        Arr.push(object);
      });
      this.selectDialogGoods.specifications = Arr;
      let goodsName = row.goodsName;
      let img = row.img;
      this.selectDialogGoods.items = [];
      row.items.map(value => {
        value.img = img;
        value.goodsName = goodsName;
      });
      this.selectDialogGoods.items = row.items;
    },
    // 翻页
    updatePage(data) {
      this.page = data.currentPage;
      this.getGoodsListData();
    },
    // 点击添加商品选取sku
    addGoodsItems() {
      if (!this.selectDialogGoods.id) {
        this.$message.error("请添加商品");
        return false;
      }
      let obj = {};
      let str = "";
      this.selectDialogGoods.specifications.map(v => {
        obj[v.title] = v.value;
        str += v.value + ";";
      });
      this.selectDialogGoods.items.map(v => {
        let specInfo = {};
        this.selectDialogGoods.specifications.map(val => {
          specInfo[val.title] = v.specInfo[val.title];
        });
        if (JSON.stringify(specInfo) === JSON.stringify(obj)) {
          let stop = false;
          this.selectDialogTableData.map(value => {
            if (value.id === v.id) {
              stop = true;
              this.$message.error("该规格已添加");
            }
          });
          if (!stop) {
            v.specificationsStr = str.substring(0,str.length - 1);
            this.selectDialogTableData.push(v);
          }
        }
      });
    },
    // 删除点击添加商品sku
    deleteGoodsItems(index) {
      this.selectDialogTableData.splice(index, 1);
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogTableVisible = false;
    },
    // 删除表格数据并判断是否为空
    removeGoods(index) {
      this.addTableData.splice(index, 1);
      if (this.addTableData.length === 0) {
        this.goodsId = "";
      }
    },
    // 清除数据
    clearTableData() {
      this.goodsId = "";
      this.addTableData = [];
    },
    // 表格合并
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        let length = this.addTableData.length + 1;
        if (rowIndex % length === 0) {
          return {
            rowspan: length,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    // 获取商品分类列表
    getGoodsClassify() {
      supplier.getSupplierClassify().then((res) => {
        if (res.success) {
          this.classify = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 弹窗点击保存按钮
    saveGoodsSku() {
      if (this.selectDialogTableData.length > 0) {
        this.goodsId = this.selectDialogGoods.id;
        let arr = [];
        this.selectDialogTableData.map(value => {
          let obj = {};
          obj.id = value.id;
          obj.goodsName = value.goodsName;
          obj.specifications = value.specificationsStr;
          obj.price = value.marketPrice;
          obj.saleNum = value.saleNum;
          obj.promotionNum = '';
          arr.push(obj);
        });
        this.closeDialog();
        this.addTableData = arr;
        this.selectDialogTableData = [];
        this.selectDialogGoods.id = "";
        this.selectDialogGoods.items = [];
        this.selectDialogGoods.specifications = [];
      } else {
        this.$message.error("请添加商品");
      }
    },
    //获取竞价商品的促销信息
    getSupplierBiddingGoodsInfo() {
      supplier.getSupplierBiddingGoodsInfo(this.id).then(res => {
        if (res.success) {
          this.goodsId = res.result.goodsId;
          this.biddingPrice = res.result.biddingPrice
          this.ruleForm.scopeNum = res.result.buyLimit
          this.ruleForm.rule = res.result.ruleType
          if (this.ruleForm.rule === 1) {
            this.reducePrice = res.result.descend
          } else if (this.ruleForm.rule === 2) {
            let arr = [];
            res.result.ladderJson.map(value => {
              let obj = {};
              obj.num = value.full;
              obj.price = value.reduce;
              arr.push(obj);
            });
            this.ladderPromotionData = arr;
          }
          let obj = {}
          obj.id = res.result.id
          obj.goodsName = res.result.goodsName
          res.result.promotionDetail.map(val => {
            obj.price = val.marketPrice
            obj.promotionNum = val.num
            let str = "";
            Object.keys(val.specInfo).forEach(key => {
              str += val.specInfo[key] + " ;";
            });
            obj.specifications = str.slice(0, str.length - 1);
          })
          this.addTableData.push(obj)
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    basePrice(num) {
      let basePrice = this.$route.query.basePrice
      if (num < basePrice) {
        this.$message.error(`当前竞拍金额必须不小于起拍价${basePrice}元`);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.add-rule {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .add-rule-main {
    .add-clear {
      height: 32px;
    }
    .el-form {
      width: 500px;
      margin-top: 20px;
      .el-radio-group {
        display: flex;
        flex-direction: column;
        .el-radio {
          align-items: center;
          display: flex;
          min-height: 32px;
          .el-input {
            width: 80px;
            margin: 0 10px;
          }
        }
      }
      .ladderlist {
        font-size: 14px;
        color: #999999;
        padding-left: 24px;
        .ladderlist-child {
          display: flex;
          .el-button {
            margin-left: 10px;
          }
        }
      }
      .addLi {
        padding-left: 24px;
      }
      .w160 {
        width: 160px;
      }
    }
    .bottom {
      height: 40px;
      .operations {
        z-index: 10;
        height: 60px;
        position: fixed;
        left: 256px;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
        .el-button {
          width: 96px;
          letter-spacing: 4px;
        }
        .el-button + .el-button {
          margin-left: 24px;
        }
      }
    }
  }
  .name {
    width: 200px;
    font-size: 12px;
    line-height: 16px;
    white-space: pre-wrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    letter-spacing: 0px;
  }
}
</style>
<style lang="scss">
.add-rule {
  .table .el-table .el-table__body-wrapper .el-table__body tr td .cell {
    height: 40px;
    display: flex;
    align-items: center;
  }
  .table {
    .el-table {
      .el-input {
        // height: 24px;
        padding-right: 16px;
        .el-input__inner {
          height: 24px;
        }
      }
      .el-table__row:first-child {
        td:nth-child(4) {
          border-left: 1px solid #f2f6fc;
          border-right: 1px solid #f2f6fc;
        }
      }
    }
  }
  .ladderlist {
    .el-input {
      width: 60px;
      .el-input__inner {
        padding: 0;
        border: 0;
        border-bottom: 1px solid #e6e8ec;
        border-radius: 0;
        text-align: center;
        height: 24px;
      }
    }
  }
  .el-form-item.is-success .el-input__inner,
  .el-form-item.is-success .el-input__inner:focus,
  .el-form-item.is-success .el-textarea__inner,
  .el-form-item.is-success .el-textarea__inner:focus {
    border-color: #ebeef2;
  }
  /* 商品弹框列表 */
  .el-dialog {
    .flex {
      display: flex;
      height: 360px;
      border-bottom: 1px solid #f7f7f7;
      .flex-left {
        max-width: 584px;
        min-width: 584px;
        padding-right: 19px;
        box-sizing: border-box;
        border-right: 1px solid #e2e2e2;
        .dialog-search {
          margin-bottom: 16px;
          .w160 {
            width: 160px;
            margin-right: 16px;
          }
          .el-input {
            width: 160px;
            margin-right: 16px;
          }
          .el-button {
            width: 60px;
          }
        }
        .table_pagination {
          display: flex;
          justify-content: flex-end;
        }
      }
      .flex-right {
        max-width: 584px;
        min-width: 584px;
        padding-left: 20px;
        box-sizing: border-box;
        .specifications {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
          .specifications-left {
            display: flex;
            align-items: center;
            .specifications-title {
              line-height: 32px;
              display: flex;
              align-items: center;
            }
            .specifications-list {
              display: flex;
              margin-left: 6px;
              .specifications-label {
                max-width: 68px;
                line-height: 32px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
              }
              .el-select {
                width: 80px;
              }
            }
          }
          .el-button {
            width: 50px;
            padding: 0;
          }
        }
      }
    }
    .dialog-footer {
      padding-top: 16px;
      display: flex;
      justify-content: center;
    }
  }
}
</style>
<style>
.rule-messageBox .el-message-box__header {
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}
</style>